import { useState, useEffect } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import { subscribe } from '../../services/utils/pubsub';

import './ConnectionStatusIcon.css';
import authService from '../../services/wss/AuthService';

const J = {
    accent: '#66b2ff',
    muted: '#a3d1ff',
    error: '#ff5f57',
};

/**
 * Connection status icon for AppBar
 * Shows CloudDone (connected), CloudOff (disconnected), CloudQueue (connecting)
 */
export default function ConnectionStatusIcon() {
    const [status, setStatus] = useState('connecting'); // connecting, connected, disconnected

    useEffect(() => {
        if (authService.isConnected()) {
            setStatus('connected');
        }

        const unsubError = subscribe('SystemSocketError', () => {
            setStatus('disconnected');
        });

        const unsubConnected = subscribe('SystemSocketConnected', () => {
            setStatus('connected');
        });

        return () => {
            unsubError();
            unsubConnected();
        };
    }, []);

    const getIcon = () => {
        switch (status) {
            case 'connected':
                return <CloudDoneIcon sx={{ color: J.accent }} />;
            case 'disconnected':
                return <CloudOffIcon sx={{ color: '#555' }} />;

            case 'connecting':
            default:
                return <CloudQueueIcon sx={{ color: J.muted, animation: 'pulse 1.5s infinite' }} />;
        }
    };

    const getTooltip = () => {
        switch (status) {
            case 'connected':
                return 'Jerny: Connected';
            case 'disconnected':
                return 'Jerny: Disconnected';
            case 'connecting':
            default:
                return 'Jerny: Connecting...';
        }
    };

    return (
        <>
            <Tooltip title={getTooltip()}>
                <IconButton size="small" sx={{ ml: 1 }}>
                    {getIcon()}
                </IconButton>
            </Tooltip>
        </>
    );
}
